import React from 'react';
import MainwireScroller from '@/modules/articles/components/scrollers/mainwire/mainwire-scroller';
import { RouteObject } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faRectangleList } from '@fortawesome/free-solid-svg-icons';
import {
  BaseScroller,
  BaseScrollerState,
} from '@/modules/articles/widgets/scrollers/base-scroller';
import { WidgetContainerContext } from '@/core/widgets/export';
import { MenuList } from '@/shared/components/export';
import SectionFilters from '@/modules/articles/components/scrollers/section-filters';

export class MainwireScrollerWidget extends BaseScroller {
  constructor(id: string, section: string[], initialState: BaseScrollerState, _shortTitle: string) {
    super(`/bullets/${id}`, section, initialState, _shortTitle);
  }
  get headerPanel(): JSX.Element {
    return (
      <>
        <WidgetContainerContext.Consumer>
          {widgetContainer => (
            <div>
              <FontAwesomeIcon icon={faRectangleList} />{' '}
              {widgetContainer.getState!<BaseScrollerState>()?.title ?? this.defaultTitle}
            </div>
          )}
        </WidgetContainerContext.Consumer>
      </>
    );
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return (
      <WidgetContainerContext.Consumer>
        {widgetContainer => {
          const sections = widgetContainer.getState<BaseScrollerState>()?.sections;
          const hasSectionPills = !!sections && sections.length > 1;

          return (
            <>
              {hasSectionPills && (
                <MenuList
                  trigger={<FontAwesomeIcon icon={faFilter} />}
                  toggleClassName={'btn btn-link p-2 text-primary-500'}
                  toggleTitle={'Filter'}
                  align={'right'}
                  footer={
                    <SectionFilters
                      disabled={false}
                      widgetId={widgetContainer.widgetId}
                      sections={sections!}
                      onFilteredDataNameChange={s =>
                        widgetContainer.updateState<BaseScrollerState>({ title: s })
                      }
                    />
                  }
                />
              )}
              {children}
            </>
          );
        }}
      </WidgetContainerContext.Consumer>
    );
  }

  get routes(): RouteObject[] {
    return [
      {
        path: '',
        element: <MainwireScroller section={this.section} includedSections={this.section} />,
      },
    ];
  }

  get defaultRoute(): string {
    return '/';
  }
}
